import { LabelsTable } from "components/Tables/LabelsTable/LabelsTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getSettingHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/setting/_layout/tag/")({
    component: TagsSettingsPage,
    staticData: {
        permissions: [PermissionEnum.SettingTags],
        showInSideMenu: false,
        label: "pages.setting.tag.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.setting.tag.title"),
        };
    },
});

function TagsSettingsPage() {
    return (
        <TenantPage headerNavigationItems={getSettingHeaderItems} isEdit={true}>
            <LabelsTable />
        </TenantPage>
    );
}
